export const extractShopifyId = (fullId: string) => {
  // Received as a GID (gid://shopify/XXX/12345678) need to extract the number
  const id = Number.parseInt(fullId.split('/').pop() ?? '');
  return id;
};
